/* ============================================================
   PPM Sticky Header
   Steuert das Scroll-Verhalten des Headers.
   Klassen werden via JS gesetzt, Styling via ppm-sticky-header.css:
     - .header-at-top   → Seitenanfang (scrollY = 0)
     - .header-reveal   → Scroll nach oben (Header einblenden)
     - .header-hide     → Scroll nach unten (Header ausblenden)
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {
  const headerElement = document.querySelector('.shopify-section-group-header-group [data-instant-type="root"] > div:last-child');
  
  // Guard clause: Exit if header isn't found
  if (!headerElement) return;

  let lastScrollY = window.pageYOffset;

  const handleScroll = () => {
    const currentScrollY = window.pageYOffset;
    
    // 1. Seitenanfang
    if (currentScrollY <= 0) {
      headerElement.classList.add('header-at-top');
      headerElement.classList.remove('header-reveal', 'header-hide');
    } 
    // 2. Scroll nach unten
    else if (currentScrollY > lastScrollY || (currentScrollY > 50 && headerElement.classList.length === 0)) {
      headerElement.classList.add('header-hide');
      headerElement.classList.remove('header-reveal', 'header-at-top');
    } 
    // 3. Scroll nach oben
    else if (currentScrollY < lastScrollY) {
      headerElement.classList.add('header-reveal');
      headerElement.classList.remove('header-hide', 'header-at-top');
    }

    lastScrollY = currentScrollY;
  };

  // Optimierter Scroll Listener
  window.addEventListener('scroll', handleScroll, { passive: true });

  // Initialzustand beim Laden der Seite setzen
  if (window.pageYOffset > 50) {
    headerElement.classList.add('header-hide');
    headerElement.classList.remove('header-at-top');
  } else {
    handleScroll();
  }
});


/* ============================================================
   PPM Cart Bubble
   Zeigt die Anzahl der Artikel im Warenkorb als Bubble 
   über dem Warenkorb-Icon an.
   Instant-update-sicher da komplett via JS gesteuert.
   Selektor: .ppm-cart-icon (via Instant Custom Class vergeben)
   ============================================================ */

const initCartBubble = () => {
  const cartIcon = document.querySelector('.ppm-cart-icon');
  if (!cartIcon) return;

  if (window.innerWidth >= 576) {
    // Auf Desktop: Bubble entfernen falls vorhanden
    const existing = document.querySelector('.ppm-cart-bubble');
    if (existing) existing.remove();
    return;
  }

  let bubble = document.querySelector('.ppm-cart-bubble');
  if (!bubble) {
    bubble = document.createElement('span');
    bubble.classList.add('ppm-cart-bubble');
    cartIcon.style.position = 'relative';
    cartIcon.appendChild(bubble);
  }

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      if (cart.item_count > 0) {
        bubble.textContent = cart.item_count;
        bubble.style.display = 'flex';
      } else {
        bubble.style.display = 'none';
      }
    });
};

document.addEventListener('DOMContentLoaded', initCartBubble);
document.addEventListener('theme:cart:change', initCartBubble);
window.addEventListener('resize', initCartBubble);